import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import lodashPull from 'lodash/pull';

import {
  LEAD_STATUS_LEASE_SIGNED,
  LEAD_STATUS_ASSIGNED,
  LEAD_STATUS_ARCHIVED,
  LEAD_STEP_STATUS_LIST,
  getLeadStatusLabel,
} from 'common/leadConstants';

import {
  makeApiRequestUrl,
} from 'api/createApiClient';
import {
  SR_API_ACTION_APARTMENT_LOCATOR_DOWNLOAD_GUEST_CARD_PDF,
} from 'api/actionTypes';

import H1 from 'client/components/H1';
import SrExternalLink from 'client/components/SrExternalLink';
import SrButtonDeprecated from 'client/components/SrButtonDeprecated';

import ApartmentLocatorAction from 'client/actions/ApartmentLocator';
import branch from 'client/core/branch';

@branch({
  currentUser: ['currentUser'],
})
class SrAgentLeadHeader extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    lead: PropTypes.object.isRequired,
    reloadTable: PropTypes.func.isRequired,
    goToLeaseForm: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
  }

  _onClick = (leadStatusOption) => {
    const { lead, dispatch, reloadTable, goToLeaseForm } = this.props;
    if (lead.status === leadStatusOption) {
      return;
    }

    if (lead.status === LEAD_STATUS_LEASE_SIGNED) {
      global.alert('Please contact Sunroom Support to change your lead’s status');
      return;
    }

    if (leadStatusOption === LEAD_STATUS_LEASE_SIGNED) {
      goToLeaseForm();
      return;
    }

    dispatch(ApartmentLocatorAction.updateLeadStatus, {
      apartmentLocatorUserId: lead.apartmentLocatorUserId,
      renterUserId: lead.renterUserId,
      fromLeadStatus: lead.status,
      toLeadStatus: leadStatusOption,
    }).then(reloadTable);
  }

  render() {
    const {
      currentUser,
      lead,
    } = this.props;
    const leadStepStatusList = lodashPull(LEAD_STEP_STATUS_LIST, LEAD_STATUS_ASSIGNED, LEAD_STATUS_ARCHIVED);
    const leadStatusIndex = leadStepStatusList.indexOf(lead.status);

    let initials = lead.renter.name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();

    return (
      <div className='headerProgress'>
        <div className='headerContentContainer'>
          <div className='avatar'>
            <span className='initials'>{initials}</span>
          </div>
          <H1>{lead.renter.name}</H1>
          {lead.status === LEAD_STATUS_ARCHIVED && (
            <span className='archived'>archived</span>
          )}
          <div className='progressStepsContainer'>
            {leadStepStatusList.map((leadStatusOption, i) => (
              <div
                key={leadStatusOption}
                className={classnames(
                  'progressStep ' + leadStatusOption,
                  {
                    active: i < leadStatusIndex,
                    currentStep: i === leadStatusIndex,
                  },
                )}
                onClick={() => this._onClick(leadStatusOption)}
              >
                <div className='stepIcon' />
                <span
                  className='label'
                  key={leadStatusOption}
                >
                  {getLeadStatusLabel({ leadStatus: leadStatusOption, isSingular: true })}
                </span>
              </div>
            ))}
          </div>
          <SrExternalLink
            className='buttonContainer'
            link={makeApiRequestUrl({
              actionType: SR_API_ACTION_APARTMENT_LOCATOR_DOWNLOAD_GUEST_CARD_PDF,
              actionPayload: {
                renterUserId: lead.renterUserId,
                apartmentLocatorUserId: currentUser.id,
              },
            })}
          >
            <SrButtonDeprecated
              className='white'
              text='guest card'
            />
          </SrExternalLink>
        </div>
      </div>
    );
  }
}

SrAgentLeadHeader.displayName = 'SrAgentLeadHeader';

export default SrAgentLeadHeader;
